import { render, staticRenderFns } from "./listMC.vue?vue&type=template&id=07f8c584&scoped=true"
import script from "./listMC.vue?vue&type=script&lang=js"
export * from "./listMC.vue?vue&type=script&lang=js"
import style0 from "./listMC.vue?vue&type=style&index=0&id=07f8c584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f8c584",
  null
  
)

export default component.exports